import { useItemIndicatorPosition } from './useItemIndicatorPosition'
import type { SharedItemData } from './types'

/**
 * Shared Item Indicator Component
 * Displays a blue circle at the exact location shared via WhatsApp URL
 * Receives parsed URL parameters from parent and renders overlay on frame
 */
interface SharedItemIndicatorProps {
  urlParams: SharedItemData
  camera: any
  frameDisplayWidth: number
  frameDisplayHeight: number
}

export function SharedItemIndicator({ urlParams, camera, frameDisplayWidth, frameDisplayHeight }: SharedItemIndicatorProps) {
  const position = useItemIndicatorPosition(urlParams, camera, frameDisplayWidth, frameDisplayHeight)

  console.log('[SharedItemIndicator] Render:', { urlParams, position, frameDisplayWidth, frameDisplayHeight })

  if (!position) {
    console.log('[SharedItemIndicator] No position calculated')
    return null
  }

  console.log('[SharedItemIndicator] ✅ RENDERING CIRCLE at:', position)

  return (
    <div
      style={{
        position: 'absolute',
        left: `${position.x}px`,
        top: `${position.y}px`,
        transform: 'translate(-50%, -50%)',
        width: `${position.radius * 2}px`,
        height: `${position.radius * 2}px`,
        borderRadius: '50%',
        border: '3px solid #2563eb', // Blue
        backgroundColor: 'rgba(37, 99, 235, 0.1)', // Subtle blue fill
        pointerEvents: 'none',
        zIndex: 100,
        transition: 'all 0.3s ease' // Smooth transitions on resize/zoom
      }}
      title="Shared item location"
    />
  )
}
